// Vendors
import React, { useState } from 'react';

const SurveyModal = ({
  surveyData,
  surveyFieldsOK,
  isOpen,
  handleSurveyInputChange,
  handleSurveySubmit,
  onClose
}) => {
  if (!isOpen) return null;

  const {
    building_cost, // acf select
    how_much_less, // acf text
    how_much_more, // acf text
    sell_speed, // acf select
    sell_cost, // acf select
    propane_barrier_other, // acf text
    home_buyer_involvement, // acf radio buttons
    environmental_benefits, // acf true false
    energy_planning_analysis_tool, // acf true false
    emissions_benefits, // acf true false
    propane_construction_research_program, // acf radio buttons
    may_we_contact_you // acf true false
  } = surveyData;

  const [showOther, setShowOther] = useState(false);

  // check if a checkbox is checked
  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      setShowOther(true);
    } else {
      setShowOther(false);
    }
  };

  const getSurveyFields = () => {
    return (
      <>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              When building a home with propane appliances, does it cost you:
              MORE, LESS, OR ABOUT THE SAME than with all-electric options?
            </label>
            <div className="form__select form__select--lg form__input--no-shadow">
              <select
                name="building_cost"
                className="form__input form__input--lg"
                value={building_cost}
                onChange={(event) => handleSurveyInputChange(event)}
              >
                <option value="">Select</option>
                <option value="more">More</option>
                <option value="less">Less</option>
                <option value="same">About the Same</option>
              </select>
            </div>
          </div>
        </div>
        {building_cost === 'less' && (
          <div className="grid__col-xs-12">
            <div className="form__field">
              <label className="form__label u--font-weight-bold">
                If less, how much less?
              </label>
              <input
                type="text"
                name="how_much_less"
                className="form__input"
                value={how_much_less}
                onChange={(event) => handleSurveyInputChange(event)}
              />
            </div>
          </div>
        )}
        {building_cost === 'more' && (
          <div className="grid__col-xs-12">
            <div className="form__field">
              <label className="form__label u--font-weight-bold">
                If more, how much more?
              </label>
              <input
                type="text"
                name="how_much_more"
                className="form__input"
                value={how_much_more}
                onChange={(event) => handleSurveyInputChange(event)}
              />
            </div>
          </div>
        )}
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Compared to all-electric homes built in your market, do propane
              homes sell FASTER, SLOWER, OR ABOUT THE SAME?
            </label>
            <div className="form__select form__select--lg form__input--no-shadow">
              <select
                name="sell_speed"
                className="form__input form__input--lg"
                value={sell_speed}
                onChange={(event) => handleSurveyInputChange(event)}
              >
                <option value="">Select</option>
                <option value="faster">Faster</option>
                <option value="slower">Slower</option>
                <option value="same">About the Same</option>
              </select>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Compared to all-electric homes, do the homes you build with
              propane have A LOWER, HIGHER, OR ABOUT THE SAME selling cost?
            </label>
            <div className="form__select form__select--lg form__input--no-shadow">
              <select
                name="sell_cost"
                className="form__input form__input--lg"
                value={sell_cost}
                onChange={(event) => handleSurveyInputChange(event)}
              >
                <option value="">Select</option>
                <option value="lower">Lower</option>
                <option value="higher">Higher</option>
                <option value="same">About the Same</option>
              </select>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              What, if any, would you say is the biggest barrier to building
              homes with propane? (Check all that apply)
            </label>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="customer"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Customer Concerns
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="dependability"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Dependability of Local Provider
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="indoor"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Indoor Air Quality Concerns
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="environmental"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Environmental Concerns
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="tank"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Tank/Equipment Safety
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="affordability"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Affordability of Installation
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="choice"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Choice of Appliances for Home
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="general"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                General Awareness of Propane
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="propane_barrier"
                  value="other"
                  onChange={(event) => handleSurveyInputChange(event)}
                  onClick={(event) => handleCheckboxChange(event)}
                />
                Other
              </label>
            </div>
          </div>
        </div>
        {showOther && (
          <div className="grid__col-xs-12">
            <div className="form__field">
              <label className="form__label u--font-weight-bold">
                If other, please specify
              </label>
              <input
                type="text"
                name="propane_barrier_other"
                className="form__input"
                value={propane_barrier_other}
                onChange={(event) => handleSurveyInputChange(event)}
              />
            </div>
          </div>
        )}
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              How would you rate your home buyer’s involvement in the energy
              choices for their home?
            </label>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="home_buyer_involvement"
                  value="total-control"
                  checked={home_buyer_involvement === 'total-control'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                1. Total Control
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="home_buyer_involvement"
                  value="significant-involvement"
                  checked={home_buyer_involvement === 'significant-involvement'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                2. Significant Involvement
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="home_buyer_involvement"
                  value="some-involvement"
                  checked={home_buyer_involvement === 'some-involvement'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                3. Some Involvement
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="home_buyer_involvement"
                  value="limited-involvement"
                  checked={home_buyer_involvement === 'limited-involvement'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                4. Limited involvement
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="home_buyer_involvement"
                  value="no-involvement"
                  checked={home_buyer_involvement === 'no-involvement'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                5. No involvement
              </label>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Do you make energy decisions for the homes you build (choosing gas
              or electricity) based on the upfront cost of equipment? Or the
              on-going cost, including energy and maintenance, for the customer
              that lives in the home?
            </label>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="energy_decisions"
                  value="upfront-cost"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Upfront Cost
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="energy_decisions"
                  value="ongoing-cost"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                On-going Cost
              </label>
            </div>
            <div>
              <label className="form__checkbox">
                <input
                  type="checkbox"
                  name="energy_decisions"
                  value="not-applicable"
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                N/A
              </label>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Do you communicate the environmental benefits of building with
              propane to your buyers
            </label>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="environmental_benefits"
                  value="true"
                  checked={environmental_benefits === 'true'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Yes
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="environmental_benefits"
                  value="false"
                  checked={environmental_benefits === 'false'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                No
              </label>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Are you able to communicate these benefits using the completed
              Energy Planning Analysis Tool as part of this program?
            </label>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="energy_planning_analysis_tool"
                  value="true"
                  checked={energy_planning_analysis_tool === 'true'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Yes
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="energy_planning_analysis_tool"
                  value="false"
                  checked={energy_planning_analysis_tool === 'false'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                No
              </label>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Are buyers more open to propane appliances after learning of the
              emissions benefits of building with propane?
            </label>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="emissions_benefits"
                  value="true"
                  checked={emissions_benefits === 'true'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Yes
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="emissions_benefits"
                  value="false"
                  checked={emissions_benefits === 'false'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                No
              </label>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              Based on your participation with the Propane Construction Research
              Program, please state your agreement with this statement: I am
              more likely to specify propane in the homes I build
            </label>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="propane_construction_research_program"
                  value="strongly-agree"
                  checked={
                    propane_construction_research_program === 'strongly-agree'
                  }
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                1. Strongly Agree
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="propane_construction_research_program"
                  value="agree"
                  checked={propane_construction_research_program === 'agree'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                2. Agree
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="propane_construction_research_program"
                  value="neither"
                  checked={propane_construction_research_program === 'neither'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                3. Neither Agree nor Disagree
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="propane_construction_research_program"
                  value="disagree"
                  checked={propane_construction_research_program === 'disagree'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                4. Disagree
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="propane_construction_research_program"
                  value="strongly-disagree"
                  checked={
                    propane_construction_research_program ===
                    'strongly-disagree'
                  }
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                5. Strongly Disagree
              </label>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">
              May we contact you for more information about your experience with
              the Propane Construction Research Program?
            </label>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="may_we_contact_you"
                  value="true"
                  checked={may_we_contact_you === 'true'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                Yes
              </label>
            </div>
            <div>
              <label className="form__radio">
                <input
                  type="radio"
                  name="may_we_contact_you"
                  value="false"
                  checked={may_we_contact_you === 'false'}
                  onChange={(event) => handleSurveyInputChange(event)}
                />
                No
              </label>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="pip-survey-modal">
      <div className="modal-content">
        <button className="btn__close" onClick={onClose}>
          X
        </button>
        <div className="scroll-content">
          <h2>Propane Construction Research Program Applicant Survey</h2>
          <div className="grid">{getSurveyFields()}</div>
          <button
            className="btn btn--lg module-hover-root btn--white"
            onClick={handleSurveySubmit}
            disabled={!surveyFieldsOK}
          >
            <span className="btn__content">
              <span className="btn__text">Submit</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SurveyModal;
